/**
 * Mode-aware wrapper for reports route.
 * Dispatches to in-person or remote page based on {@link useMode}.
 */

import { useMode } from '@/contexts/ModeContext';
import { ReportsManagementPage as ReportsInPersonManagementPage } from '@/components/pages/management-pages/inperson/ReportsManagementPage';
import { ReportsManagementPage as ReportsRemoteManagementPage } from '@/components/pages/management-pages/remote/ReportsManagementPage';

/** Mode-aware wrapper that mounts in-person or remote reports. */
export function ReportsRouteDispatcher() {
  const { mode } = useMode();

  if (mode === 'remote') {
    return <ReportsRemoteManagementPage />;
  }

  return <ReportsInPersonManagementPage />;
}
